import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var EarListen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3-7.9 15.8-1.5 34.9 14.2 42.9l.4.2c.4.2 1.1.6 2.1 1.2 2 1.2 5 3 8.7 5.6 7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7-13.9-15.1-27.8-26.1-38.2-33.3-5.3-3.7-9.7-6.4-13-8.3-1.6-1-3-1.7-4-2.2-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1h-.1l-14.3 28.6 14.2-28.7zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5 61.9 0 112 50.1 112 112 0 29.3-11.2 55.9-29.6 75.9-17 18.4-34.4 45.1-34.4 78v6.1c0 26.5-21.5 48-48 48-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176-90.6 0-165.2 68.5-174.9 156.5-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-160c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm-150.6 9.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
  }));
});
EarListen.displayName = 'EarListen';
export var EarListenDimensions = {
  height: 512,
  width: 512
};